/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, shape, string, array,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import customBreakpoints from '../../../../helpers/customBreakpoints';
import ImageSidebanner from '../../GraphqlTemplatePage/Partials/TemplatePageSales/ImageSidebanner';

const styles = (theme) => ({
    topProduct: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            width: '96%',
            margin: '0 auto',
        },
    },
    hero: {
        width: '100%',
        marginBottom: '2em',
        [theme.breakpoints.up(1025)]: {
            display: 'none',
        },
    },
    topProductContainer: {
        width: '100%',
        margin: '10px auto',
        border: `1px solid ${theme.palette.mobileMenuBG?.child}`,
        boxShadow: `0 5px 5px ${theme.palette.imageCardBoxShadow}`,
        [theme.breakpoints.down(600)]: {
            margin: '10px',
        },

    },
    dealOfWeek: {
        maxWidth: '50%',
        textAlign: 'center',
        padding: '0 25px',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            width: '46%',
            margin: '0',
        },
        [theme.breakpoints.down(600)]: {
            padding: '0 10px',
            width: '50%',
        },
    },
    dealWeekheading: {
        textAlign: 'center',
    },
    dealWeekInner: {
        fontSize: '25px',
        fontWeight: 500,
        [theme.breakpoints.down(600)]: {
            fontSize: 15,
        },
    },
    productName: {
        fontWeight: 'bold',
        fontSize: '13px',
        color: theme.palette.black,
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            fontSize: '.95rem',
        },
        [theme.breakpoints.down(600)]: {
            fontSize: '13px',
        },
    },
    productPrice: {
        color: theme.palette.black,
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            fontSize: '0.9rem',
        },
        [theme.breakpoints.down(600)]: {
            fontSize: 14,
        },
    },
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        color: theme.palette.colorAlert,
        fontWeight: 'normal',
    },
    salePrice: {
        color: theme.palette.primaryButton,
    },
    shopButton: {
        textAlign: 'center',
        color: theme.palette.white,
        fontWeight: 700,
        fontSize: 16,
        textTransform: 'uppercase',
        [theme.breakpoints.down(600)]: {
            fontSize: 14,
        },
    },
    shopButtonDiv: {
        textAlign: 'center',
        marginTop: 15,
        background: theme.palette.primaryButton,
        padding: '10px 0px',
        maxWidth: 150,
        margin: '5px auto',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            width: '90%',
            marginTop: '.5em',
        },
        [theme.breakpoints.down(600)]: {
            padding: '3px 0px',
            width: '100%',
        },
    },

    productLink: {
        textDecoration: 'none',
    },
    featuredImgContainer: {
        position: 'relative',
        maxWidth: '120%',
        '& img': {
            width: '100%',
        },
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            marginRight: 0,
            maxWidth: '50%',
        },
    },
    snipe: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
    },
    productWrapper: {
        display: 'flex',
        padding: '0 25px',
        [theme.breakpoints.down(600)]: {
            padding: '15px 10px',
        },
    },
    divider: {
        backgroundColor: theme.palette.grey8,
        border: 'none',
        height: '1px',
        width: '35%',

    },
});
let saleEntryData = {};
const getBlock = (block) => {
    const blockKey = Object.keys(block)[0];
    const blockObj = block[blockKey];
    switch (blockKey) {
        case 'sale_entry':
            saleEntryData = blockObj;
            return <ImageSidebanner bannerData={saleEntryData} />;
        default:
            return null;
    }
};
const DealOfWeek = ({
    classes, firstProduct: {
        seo: { url = '' } = {},
        image: {
            name: imageName = '', altText = '', path = '', snipe = '',
        } = {}, name = '', skuPriceRange: { sale = [], retail = [] } = {},
    } = {}, pageBlocks,
}) => {
    const seed = useUIDSeed();
    return (
        <div className={classes.topProductContainer}>
            <Link title={name} to={url} className={classes.productLink}>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        { pageBlocks.map((block) => <div key={seed(block)}> {getBlock(block)} </div>)}
                    </Grid>
                    <Grid item xs={12} sm={6} className={classes.productWrapper}>
                        <div className={classes.topProduct}>
                            <div className={classes.featuredImgContainer}>
                                <img
                                    src={`${path}${imageName}x.jpg`}
                                    alt={altText || 'deal of the week'}
                                />
                                {snipe ? ( // if snipe data exsist display snipe img
                                    <img
                                        className={classes.snipe}
                                        src={`${path}${snipe}_z.gif`}
                                        alt={altText}
                                    />
                                ) : null}
                            </div>
                            <div className={classes.dealOfWeek}>
                                <div className={classes.dealWeekheading}>
                                    <div className={classes.dealWeekInner} style={{ color: saleEntryData?.main_image_text_color  }}>
                                        {saleEntryData?.main_image_text}
                                    </div>
                                    <hr className={classes.divider} />
                                </div>
                                <div className={classes.botttomContainer}>
                                    <div className={classes.botttomContainerInner}>
                                        <div className={classes.productName}>{name}</div>
                                        <div className={classes.productPrice}>
                                            {(sale?.[0]?.value.toString() === retail?.[0]?.value.toString() && sale?.[1]?.value?.toString() === retail?.[1]?.value?.toString()) ? (
                                                `$${retail?.[0]?.value} - $${retail?.[1]?.value}`
                                            ) : (
                                                <>
                                                    <span className={classes.crossedOutRetailPrice}>${retail?.[0]?.value} - ${retail?.[1]?.value}</span> <span className={classes.salePrice}>SALE ${sale?.[0]?.value} - ${sale?.[1]?.value}</span>
                                                </>
                                            )}
                                        </div>
                                        <div className={classes.shopButtonDiv}>
                                            <span className={classes.shopButton}>Shop now</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Link>
        </div>
    );
};
DealOfWeek.propTypes = {
    classes: object,
    pageBlocks: array.isRequired,
    firstProduct: shape({
        image: shape({
            name: string,
            altText: string,
        }),
        name: string,
        seo: shape({
            url: string,
        }),
    }),
};
DealOfWeek.defaultProps = {
    classes: {},
    firstProduct: {},
};

export default withStyles(styles)(DealOfWeek);
